import { autoinject, transient } from "aurelia-framework";
import { BaseActivityConfiguration } from "../base-activity-configuration";
import { WorkflowConfigurationService } from "../../../../services/workflow/workflow-configuration-service";

@autoinject()
@transient()
export class LegacyCommentsActivityConfiguration extends BaseActivityConfiguration {

    constructor(workflowConfigurationService: WorkflowConfigurationService) {
        super(workflowConfigurationService);
    }
}